/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React from 'react';

import { Banner } from '@forge/common';

import { NotificationBannerProps } from '../../models/viewdevice';

const NotificationBanner: React.FC<NotificationBannerProps> = ({
  variant, type, title, description, canClose = true, actions
}) => (
  <div className="grid grid-flow-row auto-rows-auto gap-4">
    <Banner variant={variant} type={type}
      title={title} description={description}
      canClose={canClose} actions={actions || []}
    />
  </div>
);

export default NotificationBanner;